/**
 * Wrapper information Modal
 */

// React
import React, { FC } from 'react';

// Material
import { styled } from '@mui/material/styles';
import { Box, Dialog, Breakpoint, Typography, DialogContent, DialogActions } from '@mui/material';
import Grid from '@mui/material/Grid2';

// Common styles
import { ButtonUpdate, CustomTableContainer } from 'styles';

// Styled
const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F2F1F1',
    maxWidth: '98%',
  },
});

const StyledDialogTitle = styled(Box)({
  width: '100%',
  marginBottom: '18px',
});

const TableContainerSmall = styled(CustomTableContainer)(({ theme }) => ({
  paddingRight: '10px',
  paddingBottom: '35px',
  [theme.breakpoints.down('md')]: {
    paddingBottom: '10px',
  },
}));

const CustomDialogActions = styled(DialogActions)({
  paddingTop: '33px',
  paddingBottom: '12px',
});

const StyledGridContainer = styled(Grid)({
  width: '100%',
  fontWeight: 400,
  marginTop: '18px',
});

const ScrollableBox = styled(Box)({
  maxHeight: '50vh',
  overflowY: 'auto',
  paddingRight: '10px',
});

const GridCustom = styled(Grid)(({ theme }) => ({
  color: '#666666',
  fontWeight: '500',
  fontFamily: '"Noto Sans JP", sans-serif',
  [theme.breakpoints.down('md')]: {
    fontSize: '14px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '13px',
  },
}));

interface InformationModalProps {
  open: boolean;
  title: string;
  textButton?: string;
  paddingLeft?: string;
  maxWidth?: Breakpoint;
  handleCloseInformation: () => void;
  generalDataInformation: {
    label: string;
    value: any;
  }[];
  children: React.ReactNode | React.ReactElement;
}

// Component
const WrapperInformationModal: FC<InformationModalProps> = ({
  open,
  title,
  children,
  handleCloseInformation,
  paddingLeft,
  maxWidth = 'xl',
  textButton = '戻る',
  generalDataInformation,
}) => {
  return (
    <StyledDialog open={open} onClose={handleCloseInformation} maxWidth={maxWidth}>
      <StyledDialogTitle>
        <Typography variant="h3" color="#666666" fontWeight={500}>
          {title}
        </Typography>
        <StyledGridContainer spacing={0.5} container sx={{ paddingLeft: paddingLeft }}>
          {generalDataInformation?.map(({ label, value }, index) => (
            <React.Fragment key={index}>
              <GridCustom size={4}>{label}</GridCustom>
              <GridCustom size={{ md: 5, xs: 8 }}>{value}</GridCustom>
            </React.Fragment>
          ))}
        </StyledGridContainer>
      </StyledDialogTitle>
      <DialogContent>
        <TableContainerSmall>
          <ScrollableBox className="table-container">{children}</ScrollableBox>
        </TableContainerSmall>
      </DialogContent>
      <CustomDialogActions>
        <ButtonUpdate
          sx={{ mt: 0 }}
          onClick={handleCloseInformation}
          color="primary"
          variant="contained"
          autoFocus
        >
          {textButton}
        </ButtonUpdate>
      </CustomDialogActions>
    </StyledDialog>
  );
};

export default WrapperInformationModal;
